import { Association } from './assoication';

export interface ILicenseInfo {
  State?: string;
  Number?: string;
  Exempt?: boolean;
  Raw?: string;
  Prefix?: string;
  Computed?: string;
  Expire?: Date;
  StateExempt?: boolean;
}

export interface ISchoolInfo {
  Key?: string;
  Name?: string;
  AddressKey?: string;
  Line1?: string;
  Line2?: string;
  City?: string;
  State?: string;
  Zip?: string;
  PhoneKey?: string;
  Phone?: string;
  IsInstructorReferral?: boolean;
}

export interface ITrainingRecord {
  Key?: string;
  IndividualKey?: string;
  Association?: Association;
  License1: ILicenseInfo;
  License2: ILicenseInfo;
  School: ISchoolInfo;
  CourseLength?: number;
  GraduationDate?: Date;
  NameAttended?: string;
  Primary?: boolean;
  Added?: Date;
  Updated?: Date;
}

export class TrainingRecord implements ITrainingRecord {

  public Key: string = undefined;
  public IndividualKey: string = undefined;
  public Association: Association = undefined;
  public License1: LicenseInfo = undefined;
  public License2: LicenseInfo = undefined;
  public School: SchoolInfo = undefined;
  public CourseLength: number = undefined;
  public GraduationDate: Date = undefined;
  public NameAttended: string = undefined;
  public Primary: boolean = undefined;
  public Added: Date = undefined;
  public Updated: Date = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          if (key === 'License1') {
            this.License1 = new LicenseInfo(source[key]);
          } else if (key === 'License2') {
            this.License2 = new LicenseInfo(source[key]);
          } else if (key === 'School') {
            this.School = new SchoolInfo(source[key]);
          } else if (key === 'GraduationDate' || key === 'Added' || key === 'Updated') {
            this[<any>key] = source[key] == null ? null : new Date(source[key]);
          } else {
            this[key] = source[key];
          }
        }
      }
    }

    if (!this.License1) {
      this.License1 = new LicenseInfo();
    }

    if (!this.License2) {
      this.License2 = new LicenseInfo();
    }

    if (!this.School) {
      this.School = new SchoolInfo();
    }
  }

}

export class LicenseInfo implements ILicenseInfo {

  public State: string = undefined;
  public Number: string = undefined;
  public Exempt: boolean = undefined;
  public Raw: string = undefined;
  public Prefix: string = undefined;
  public Computed: string = undefined;
  public Expire: Date = undefined;
  public StateExempt: boolean = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          if (key === 'Expire') {
            this.Expire = source[key] == null ? null : new Date(source[key]);
          } else {
            this[key] = source[key];
          }
       } else {
         if (key == 'Exempt') {
          this.Exempt = false;
         } else {
          this[key] = null;
         }
       }
      }
    }
  }

}

export class SchoolInfo implements ISchoolInfo {

  public Key: string = undefined;
  public Name: string = undefined;
  public AddressKey: string = undefined;
  public Line1: string = undefined;
  public Line2: string = undefined;
  public City: string = undefined;
  public State: string = undefined;
  public Zip: string = undefined;
  public PhoneKey: string = undefined;
  public Phone: string = undefined;
  public IsInstructorReferral: boolean = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }

}

export enum SkeletonActions {
  TEMPLATE = 1,
  ADD = 2,
  SKIP = 8,
};
